<template>
  <div class="search-nav-year-month">
    <span class="year-month-title">{{label}}</span>
    <span><search-nav-item-select v-model="year" :list="yearList" @change="onChangeData"/>년</span>
    <span><search-nav-item-select v-model="month" :list="monthList" @change="onChangeData"/>월</span>
  </div>
</template>

<script>
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
export default {
  name: 'SearchNavYearMonth',
  components: {SearchNavItemSelect},
  props:{
    label: {
      default: '대상기간',
      type: String
    },
    value: Object
  },
  computed: {
    yearList () {
      let nowYear = new Date().getFullYear()
      const yearList = []
      yearList.push({text:'전체',  value:''})
      for (let i = 0; i < 50; i++) {
        yearList.push({text:`${nowYear}`,  value:nowYear})
        nowYear--
      }
      return yearList
    },
    monthList () {
      return [
        {text:'전체', value:''},
        {text:'1', value:'1'},
          {text:'2', value:'2'},
          {text:'3', value:'3'},
          {text:'4', value:'4'},
          {text:'5', value:'5'},
          {text:'6', value:'6'},
          {text:'7', value:'7'},
          {text:'8', value:'8'},
          {text:'9', value:'9'},
          {text:'10', value:'10'},
          {text:'11', value:'11'},
          {text:'12', value:'12'}
      ]
    }
  },
  data () {
    return {
      year: this.value && this.value.year ? this.value.year  : new Date().getFullYear(),
      month: this.value && typeof this.value.month !== 'undefined'  ? this.value.month  : new Date().getMonth() + 1
    }
  },
  created () {
    this.$emit('input', {year: this.year, month:this.month})
  },
  methods: {
    onChangeData () {
      this.$emit('input', {year: this.year, month:this.month})
      this.$emit('change', {year: this.year, month:this.month})
    }
  }
}
</script>

<style lang="scss" scoped>
.search-nav-year-month {
  display: flex;

  .year-month-title { white-space: nowrap;}

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }


}
</style>
